/**
 * InboxIcon/index.js
 * desc: inbox icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const InboxIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="inbox icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.inbox.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M1.99 0H16a2 2 0 012 2v14c0 1.1-.9 2-2 2H1.99C.88 18 0 17.1 0 16L.01 2c0-1.11.87-2 1.98-2zM12 12h4V2H2v10h4c0 1.66 1.35 3 3 3s3-1.34 3-3z" /></svg>
    </IconButton>
);


export default InboxIcon;
